if (!customElements.get("trusted-by-slider")) {
    class TrustedBySlider extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.initSlider();
        }

        initSlider() {
            if (typeof MinimogLibs !== 'undefined' && MinimogLibs.Swiper) {
                this.slider = new MinimogLibs.Swiper(this, {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    loop: true,
                    autoplay: {
                        delay: 1500,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                            loop: false,
                            autoplay: false
                        },
                        1024: {
                            slidesPerView: 5,
                            spaceBetween: 40,
                            loop: false,
                            autoplay: false
                        }
                    }
                });
            }
        }
    }

    customElements.define("trusted-by-slider", TrustedBySlider);
}
